import barcodeScannerMiddleware from './middleware';

export default barcodeScannerMiddleware;